export default __webpack_public_path__ + "static/media/car07.4b676d9a.jpg";